module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/jtgh.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fjtgh.png
// module id = 3Q77
// module chunks = 93